import { LightDocumentObjectModelNexusComponent } from "./light-document-object-model-nexus-component";
import { DebounceModule } from "./debounce.module";

/**
 * 
 */
export class HorizontalScrollContainerComponent extends LightDocumentObjectModelNexusComponent {

    intersectionObserver = null;
    debounceModule = new DebounceModule();

    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
    }

    setEventListeners() {
        this.setButtonEventListeners();
        this.setResizeEventListeners();
        this.setMouseEventListeners();
        this.setScrollEventListeners();
        this.setWindowEvents();
    }

    setWindowEvents() {
        window.addEventListener('focus', () => {

        });
        window.addEventListener('blur', () => {
            this.getHorizontalScrollElement().removeEventListener('mousemove', this.boundMouseMoveHandler);
        });
    }

    setResizeEventListeners() {
        // window.addEventListener('resize', () => {
        document.documentElement.addEventListener('viewport-width-resizing', () => {
            this.cachedHorizontalScrollColumnWidth = this.getFullWidth(this.renderRoot.querySelector('.horizontal-scroll-column'));
            this.getHorizontalScrollElement().scrollLeft = 0;
            this.handleScrollStates();
        });
        // });
    }

    setButtonEventListeners() {
        this.getPreviousButtonElement().addEventListener('click', (event) => {
            event.preventDefault();
            let newPreviousScrollLeftPosition = Math.max(0, this.getHorizontalScrollElement().scrollLeft - this.cachedHorizontalScrollColumnWidth);
            if (newPreviousScrollLeftPosition >= 0) {
                this.getHorizontalScrollElement().scroll({
                    left: newPreviousScrollLeftPosition,

                });
            }
        });

        this.getNextButtonElement().addEventListener('click', (event) => {
            event.preventDefault();
            let newNextScrollLeftPosition = this.getHorizontalScrollElement().scrollLeft + this.cachedHorizontalScrollColumnWidth;
            let maxScrollLeft = this.getMaxScrollLeft() + this.cachedHorizontalScrollColumnWidth;
            if (newNextScrollLeftPosition <= maxScrollLeft) {
                this.getHorizontalScrollElement().scroll({
                    left: newNextScrollLeftPosition
                });
            }
        });
    }

    handleScrollStates() {
        let scrollLeft = this.getHorizontalScrollElement().scrollLeft;
        // console.log('scrollLeft', scrollLeft);
        this.setDataAttributesForStartState(scrollLeft);
        this.setDataAttributesForEndState(scrollLeft);
    }

    setDataAttributesForStartState(scrollLeft) {
        if (scrollLeft == 0) {
            // &[data-start-state-reached="true"] {
            this.renderRoot.dataset.startStateReached = 'true';
        }
        if (scrollLeft > 0) {
            delete this.renderRoot.dataset.startStateReached;
        }
    }

    getMaxScrollLeft() {
        let maxScrollLeft = (this.getHorizontalScrollElement().scrollWidth - this.getHorizontalScrollElement().clientWidth);
        return maxScrollLeft;
    }

    setDataAttributesForEndState(scrollLeft) {
        let maxScrollLeft = this.getMaxScrollLeft();
        if (scrollLeft >= maxScrollLeft) {
            //     // &[data-end-state-reached="true"] {
            this.renderRoot.dataset.endStateReached = 'true';
        }
        if (scrollLeft < maxScrollLeft) {
            delete this.renderRoot.dataset.endStateReached;
        }
    }

    /**
     * cache the scroll position. When navigating back to a page, scroll left position can be non-0
     */
    setCaches() {
        this.cachedHorizontalScrollColumnWidth = this.getFullWidth(this.renderRoot.querySelector('.horizontal-scroll-column'));
        console.log('caches set', this);
    }

    getFullWidth(element) {
        let elementComputedStyle = window.getComputedStyle(element, null);
        return element.offsetWidth + parseInt(elementComputedStyle.getPropertyValue('margin-left')) + parseInt(elementComputedStyle.getPropertyValue('margin-right'));
    }

    firstUpdated() {
        // this.stateMachineModule.addEventListenerForStateMachine('tick', document.documentElement, this.actors, this);
        // this.stateMachineModule.addEventListenerForStateMachine('scrolling', this.getHorizontalScrollElement(), this.actors, this);
        // this.stateMachineModule.addEventListenerForStateMachine('viewport-width-resizing', document.documentElement, this.actors, this);
        // this.stateMachineModule.setInitializedState(this.actors, this);
        this.setCaches();
        this.setEventListeners();
        this.handleScrollStates(); // initial handling
    }

    getHorizontalScrollElement() {
        return this.querySelector('.horizontal-scroll');
    }

    getPreviousButtonElement() {
        let prev = this.renderRoot.querySelector(':not([data-start-state-reached="true"]) .horizontal-scroll-navigation-previous');
        console.log('prev', prev);
        return prev;
    }

    getNextButtonElement() {
        let next = this.renderRoot.querySelector(':not([data-end-state-reached="true"]) .horizontal-scroll-navigation-next');
        console.log('next', next);
        return next;
    }

    setScrollEventListeners() {
        this.getHorizontalScrollElement().addEventListener('scroll', (event) => {
            // console.log('scroll', event);
            this.handleScrollStates();
        });

        if (window.IntersectionObserver) {
            let callBack = (entries, observer) => {
                entries.forEach((entry) => {
                    // console.log('entry', entry);
                    if (entry.target) {
                        /**
                         * @var {IntersectionObserverEntry} entry
                         */
                        let target = entry.target;
                        let isIntersecting = entry.isIntersecting;
                        if (isIntersecting === true) {
                            target.classList.add('is-intersecting');
                            target.classList.remove('is-not-intersecting');
                            // this.getWidth(horizontalScrollContainer, 'full')
                            if (
                                entry.intersectionRatio < 1.0
                            ) {
                            }
                            target.style.opacity = entry.intersectionRatio.toFixed(2);
                        }
                        if (isIntersecting === false) {
                            target.classList.add('is-not-intersecting');
                            target.classList.remove('is-intersecting');
                        }
                    }
                });
            };
            let intersectionObserverThresholds = [];
            for (let index = 0.00; index < 1; index = index + 0.10) {
                intersectionObserverThresholds.push(index);

            }
            let intersectionObserverConfiguration = {
                root: this.getHorizontalScrollElement(),
                threshold: intersectionObserverThresholds
            };
            this.intersectionObserver = new IntersectionObserver(callBack, intersectionObserverConfiguration);
            let horizontalScrollItems = this.renderRoot.querySelectorAll('.navigation-item');
            horizontalScrollItems.forEach((horizontalScrollItem) => {
                this.intersectionObserver.observe(horizontalScrollItem);
            });
        }
    }

    /**
     * @see https://htmldom.dev/drag-to-scroll/
     */
    setMouseEventListeners() {
        this.getHorizontalScrollElement().style.cursor = 'default';
        let images = this.getHorizontalScrollElement().querySelectorAll('a, img');
        if (images) {
            images.forEach(function (image) {
                image.setAttribute('draggable', false);
            })
        }

        // TODO: re-introduce no arrows if they're not needed
        // TODO: photo slider compatibility

        // Attach the handler
        this.boundOnHorizontalScrollMouseDown = this.mouseDownHandler.bind(this, this);
        this.getHorizontalScrollElement().addEventListener('mousedown', this.boundOnHorizontalScrollMouseDown);
    }

    mouseDownHandler = (thisArg, mouseDownEvent) => {
        // console.log('mouseDownHandler', thisArg, horizontalScroll, pos, mouseDownEvent);
        mouseDownEvent.preventDefault(); // Firefox disable drag (see https://www.redips.net/firefox/disable-image-dragging/)

        this.getHorizontalScrollElement().style.cursor = 'default';
        this.getHorizontalScrollElement().style.userSelect = 'none';
        this.position = {
            left: this.getHorizontalScrollElement().scrollLeft,
            top: this.getHorizontalScrollElement().scrollTop,
            // Get the current mouse position
            x: mouseDownEvent.clientX,
            y: mouseDownEvent.clientY,
        };
        this.boundMouseUpHandler = this.mouseUpHandler.bind(this, this, this.getHorizontalScrollElement());
        this.boundMouseMoveHandler = this.mouseMoveHandler.bind(this, this, this.position);
        document.addEventListener('mousemove', this.boundMouseMoveHandler);
        document.addEventListener('mouseup', this.boundMouseUpHandler);
    };

    mouseMoveHandler = (thisArg, position, mouseMoveEvent) => {
        // console.log('mouseMoveHandler', this, thisArg, horizontalScroll, pos, mouseMoveEvent);
        // How far the mouse has been moved
        const dx = mouseMoveEvent.clientX - position.x;
        const dy = mouseMoveEvent.clientY - position.y;
        this.getHorizontalScrollElement().scrollTop = position.top - dy;
        this.getHorizontalScrollElement().scrollLeft = position.left - dx;
        // document.removeEventListener('mousemove', this.boundMouseMoveHandler);
    }

    mouseUpHandler = (e, horizontalScroll) => {
        // // console.log('mouseUpHandler', e, horizontalScroll)
        // horizontalScroll.style.cursor = 'default';
        // horizontalScroll.style.removeProperty('user-select');
        // // horizontalScroll.style.scrollBehavior = 'smooth';
        // horizontalScroll.style.pointerEvents = 'all';
        // document.addEventListener('mousemove', this.boundMouseMoveHandler);

        // // mouseEvent.preventDefault();
        // // console.log('onHorizontalScrollMouseUp', this, horizontalScroll, mouseEvent);
        // // TODO: also handle updating of current item here, so arrow nav will work nicely also
        // let horizontalScrollItems = horizontalScroll.querySelectorAll(this.horizontalScrollItemSelector);

        // let closestContainer = horizontalScroll.closest(`${this.containerSelector}, ${this.horizontalScrollContainerSelector}`);
        // if (horizontalScrollItems) {
        // 	// console.log('scrollLeft', horizontalScroll.scrollLeft);
        // 	for (let index = 0; index < horizontalScrollItems.length; index++) {
        // 		const horizontalScrollItem = horizontalScrollItems[index];
        // 		// console.log('h', index, 'offsetLeft', horizontalScrollItem.offsetLeft, ', offsetWidth', horizontalScrollItem.offsetWidth, ', combined offset thingy', ((horizontalScrollItem.offsetLeft + horizontalScrollItem.offsetWidth)));
        // 		if (
        // 			horizontalScroll.scrollLeft >= (horizontalScrollItem.offsetLeft) &&
        // 			horizontalScroll.scrollLeft < (horizontalScrollItem.offsetLeft + horizontalScrollItem.offsetWidth)
        // 		) {
        // 			// update based on scroll
        // 			closestContainer.dataset.currentItem = index;
        // 			// console.log('between');
        // 		}

        // 	}
        // }

        document.removeEventListener('mousemove', this.boundMouseMoveHandler);
        document.removeEventListener('mouseup', this.boundMouseUpHandler);
    };

}

// TODO: improve naming
window.customElements.define('horizontal-scroll-container', HorizontalScrollContainerComponent);